import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import Spinner from "../../../components/spinner";
import { useProcessStripePayment } from "@/hooks/useInvestments";
import { WorkflowContainer } from "../WorkflowContainer";
import { useWorkflowContext } from "@/pages/workflow/context/WorkflowContext";
import { Heading } from "@equidefi/ui";
import { useToast } from "@chakra-ui/react";

const getReturnTo = (step) => {
  const nextStep = step !== "PAYMENT" ? step : "ADDRESS";
  return String(nextStep).toLowerCase();
};

const WorkflowPaymentProcessing = () => {
  const { investment, offering, user, refetchInvestment } =
    useWorkflowContext();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const toast = useToast();

  const processPayment = useProcessStripePayment(investment.id, {
    onSuccess: async (nextStep) => {
      await refetchInvestment();
      const returnTo = getReturnTo(nextStep);
      if (investment.expedited) {
        navigate(`/offerings/${offering.slug}/${investment?.id}/agreement`);
      } else {
        navigate(`/offerings/${offering.slug}/${investment?.id}/${returnTo}`);
      }
    },
    onError: () => {
      toast({ status: "error", description: "Payment failed to process." });
      navigate(`/offerings/${offering.slug}/${investment?.id}/payment`, {
        replace: true,
        state: { returnTo: getReturnTo(investment.next) },
      });
    },
  });

  useEffect(() => {
    const run = async () => {
      setIsLoading(true);
      await processPayment.mutateAsync(searchParams.get("payment_intent"));
    };

    if (!isLoading) {
      run();
    }
  }, []);

  return (
    <WorkflowContainer>
      <Heading fontWeight="bold" textStyle="h1" textAlign="center">
        Payment Processing...
      </Heading>
      <Spinner show />
    </WorkflowContainer>
  );
};

export default WorkflowPaymentProcessing;
